import axios from "axios";
const https = require('https');

const selfCerthttpsAgent = new https.Agent({
  rejectUnauthorized: false
});

export default class PersonService {
 
    private static instance: PersonService;
  
    baseUrl: string;
    private constructor() { 
  
      const baseUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_BASE_URL : process.env.REACT_APP_DEV_BASE_URL;
      this.baseUrl = baseUrl! + '/person';
    }
  
    public static getInstance(): PersonService {
      if (!PersonService.instance) {
        PersonService.instance = new PersonService();
      }
      return PersonService.instance;
    }

 getPersonDetails = (site: string, name: string): Promise<any> => {
  return axios.get(this.baseUrl + '/details', {
    params: {
      site: site,
      name: name
    },
    httpsAgent: selfCerthttpsAgent,
    timeout: 60000,
    headers: {
      "API_KEY": process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_PROD_KEY : process.env.REACT_APP_API_DEV_KEY
    }
  }).then((response) => {
        return response.data;
  })
  .catch((error) => {
    return error.response;
  });
 };

}